<template>
    <svg
        width="84"
        height="84"
        viewBox="0 0 84 84"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.9334 40.0796C48.3138 40.0339 54.6943 46.659 61.3151 59.9591C59.8622 50.7277 55.2436 42.2937 50.0072 34.7079C50.0072 34.7079 54.3479 37.0395 56.4794 41.1866C57.7165 35.4372 56.4639 30.6117 55.6728 24.4139C61.3501 36.8566 59.72 46.2016 59.72 46.2016C59.72 46.2016 60.9997 44.1117 61.787 41.4742C61.787 41.4742 62.2303 47.1309 61.3436 50.814C61.3436 50.814 63.395 48.4915 63.8875 46.8486C63.8875 46.8486 67.9916 60.874 65.9557 72.9402L70.5497 69.0244C67.7925 77.1866 63.1985 82.9936 63.1985 82.9936C81.1816 70.253 79.6718 60.2976 79.6718 60.2976C73.8964 52.8647 68.9081 41.3853 63.0667 24.197C57.8612 8.87765 44.7824 2.52041 42.0006 1.32059L41.9347 1.34934L41.8688 1.32059C39.087 2.52041 26.0069 8.87765 20.8014 24.197C14.96 41.384 9.97174 52.8647 4.19625 60.2976C4.19625 60.2976 2.68645 70.2517 20.6696 82.9936C20.6696 82.9936 16.0756 77.1866 13.3197 69.0244L17.9137 72.9402C15.8791 60.874 19.9819 46.8486 19.9819 46.8486C20.4744 48.4915 22.5258 50.814 22.5258 50.814C21.6403 47.1309 22.0824 41.4742 22.0824 41.4742C22.8696 44.1117 24.1493 46.2016 24.1493 46.2016C24.1493 46.2016 22.5206 36.8566 28.1966 24.4139C27.4055 30.6117 26.1529 35.4372 27.39 41.1866C29.5228 37.0395 33.8622 34.7079 33.8622 34.7079C28.627 42.2937 24.0059 50.7264 22.5542 59.9591C29.1751 46.659 35.5555 40.0339 41.936 40.0796H41.9347H41.9334Z"
            fill="url(#paint0_linear_2420_4048)"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.8805 52.2012C30.8805 52.2012 32.7422 54.2009 36.0224 54.8284L38.6142 53.9075C38.6142 53.9075 32.6874 52.8726 30.8789 52.2012H30.8805Z"
            fill="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53.1107 52.2013C53.1107 52.2013 51.249 54.201 47.9688 54.8285L45.377 53.9077C45.377 53.9077 51.3038 52.8728 53.1123 52.2013H53.1107Z"
            fill="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M63.9245 42.8165C62.0153 29.2812 55.6775 24.4126 55.6775 24.4126C61.3548 36.8553 59.7248 46.2003 59.7248 46.2003C59.7248 46.2003 61.0045 44.1104 61.7917 41.4729C61.7917 41.4729 62.2351 47.1296 61.3483 50.8127C61.3483 50.8127 63.3997 48.4902 63.8922 46.8473C63.8922 46.8473 67.9963 60.8727 65.9604 72.9389C71.2124 56.2772 64.8436 40.0273 64.8436 40.0273L63.9245 42.8152V42.8165ZM19.9543 42.8178C21.8635 29.2825 28.2013 24.4139 28.2013 24.4139C22.524 36.8566 24.1541 46.2016 24.1541 46.2016C24.1541 46.2016 22.8756 44.1117 22.0871 41.4742C22.0871 41.4742 21.6438 47.1309 22.5305 50.814C22.5305 50.814 20.4791 48.4915 19.9866 46.8486C19.9866 46.8486 15.8838 60.874 17.9184 72.9402C12.6664 56.2785 19.0352 40.0286 19.0352 40.0286L19.9543 42.8165V42.8178ZM71.4439 65.9478L71.4437 65.9501L71.4424 65.9488L71.4439 65.9478ZM71.4439 65.9478C72.0253 59.3531 71.5894 51.2135 68.1785 38.2823C71.9956 47.9645 75.6409 55.1151 79.6674 60.2973C79.6674 60.2973 81.1772 70.2514 63.1941 82.9934C63.1941 82.9934 72.5915 74.7423 75.085 63.5936L71.4439 65.9478ZM12.5516 65.948L12.5518 65.9503L12.5531 65.949L12.5516 65.948ZM15.817 38.2824C12.4061 51.2137 11.9702 59.3533 12.5516 65.948L8.91047 63.5938C11.404 74.7425 20.8014 82.9935 20.8014 82.9935C2.81829 70.2516 4.32808 60.2975 4.32808 60.2975C8.35464 55.1153 11.9999 47.9647 15.817 38.2824ZM33.9972 34.7071C33.9972 34.7071 33.1634 37.9446 33.0316 40.1351H33.0342C39.5542 36.4272 45.0453 36.9565 51.0173 40.9311L50.0129 34.7071C55.2494 42.293 59.868 50.727 61.3209 59.9584C48.1244 33.4498 35.8857 33.4498 22.6892 59.9584C24.1408 50.7257 28.7607 42.293 33.9972 34.7071Z"
            fill="url(#paint1_linear_2420_4048)"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.7957 3.37793C44.6899 4.57906 58.3013 10.935 63.7188 26.2556C64.3961 28.173 65.0631 30.0198 65.7224 31.7986C64.8511 29.399 63.9631 26.8686 63.0569 24.1997C57.8502 8.87909 44.77 2.52185 41.9896 1.32202L41.9237 1.35078L41.8577 1.32202C39.2583 2.44343 27.6633 8.07005 21.9072 21.3073C28.1506 9.53912 39.098 4.44052 41.6587 3.37924L41.7272 3.40799L41.7957 3.37924V3.37793Z"
            fill="#717B8E"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2420_4048"
                x1="41.934"
                y1="-0.307493"
                x2="41.934"
                y2="81.3928"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#5C6474" />
                <stop offset="1" stop-color="#353841" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_2420_4048"
                x1="41.9977"
                y1="23.2449"
                x2="41.9977"
                y2="81.8453"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#3D434E" />
                <stop offset="1" stop-color="#1C1E24" />
            </linearGradient>
        </defs>
    </svg>
</template>
<script>
export default {
    data() {
        return {};
    },
};
</script>
